import { isBefore, parseISO } from 'date-fns';

export const minimumDateValidation = (date?: string) => {
  if (!date) {
    return false;
  }

  return isBefore(parseISO(date), parseISO('1900-01-01'));
};
